export default function releaseNotesService($http, RESOURCES) {
  return {
    getReleaseNote: getReleaseNote,
    updateReleaseNote: updateReleaseNote,
  };

  function getReleaseNote(language) {
    const params = { language: language };
    return $http.get(RESOURCES.RELEASE_NOTES, { params: params });
  }

  function updateReleaseNote(language, releaseNotes) {
    const params = { language: language };
    return $http.put(RESOURCES.RELEASE_NOTES, { releaseNoteDtos: releaseNotes }, { params: params });
  }
}



// WEBPACK FOOTER //
// ./src/app/content-editor/bc/releaseNotes/releaseNotes.service.js